import { BIOMETRICS_FLOW } from "@repo/core/services/entities/Biometrics";
import type { RegisterBiometryStepProps } from "@repo/core/hooks/useBiometryRegister";
import type { UnicoCreateProcessResponse } from "@repo/core/services/entities/Unico";

type RegisterBiometryStepLogFn = (
  props: RegisterBiometryStepProps
) => Promise<unknown>;

function hasProcessSelfie(
  selfie: UnicoCreateProcessResponse["selfie"]
): selfie is NonNullable<UnicoCreateProcessResponse["selfie"]> {
  return (
    selfie != null &&
    typeof selfie === "object" &&
    (Boolean(selfie.fileContents?.trim()) || Boolean(selfie.contentType?.trim()))
  );
}

/**
 * Registers Único biometry flow step `SELFIE` after proposal document uploads.
 * Runs only when `GET /unico/process/:id` included `selfie`. `strRetorno` is the serialized
 * `selfie` payload; `strNumeroDocumento` is `lngDocumento` from the BIOMETRY (selfie) upload only.
 * Non-blocking (hook swallows errors).
 */
export function registerUnicoSelfieStepAfterDocumentUploads(
  registerBiometryStepLog: RegisterBiometryStepLogFn,
  lngProposta: number | undefined,
  lngDocumentoForSelfieRegistration: string | undefined,
  processSelfie: UnicoCreateProcessResponse["selfie"]
): Promise<unknown> {
  const docId = lngDocumentoForSelfieRegistration?.trim();
  if (!lngProposta || !docId || !hasProcessSelfie(processSelfie)) {
    return Promise.resolve();
  }

  return registerBiometryStepLog({
    step: BIOMETRICS_FLOW.SELFIE,
    lngProposta,
    response: processSelfie as object,
    strNumeroDocumento: docId
  });
}
